import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { HeroPartner } from '../components/partner/HeroPartner';
import { SoFunktioniertPartner } from '../components/partner/SoFunktioniertPartner';
import PricingCards from '../components/PricingCards';
import { WarumPartner } from '../components/partner/WarumPartner';
import { WieEsFunktioniert } from '../components/partner/WieEsFunktioniert';
import { PartnerCTA } from '../components/partner/PartnerCTA';
import { Footer } from '../components/Footer';
import { Calculator } from 'lucide-react';

const PartnerPage = () => {
  const navigate = useNavigate();

  const handleSelectPackage = (planId) => {
    navigate(`/partner/abo?plan=${planId}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Partner werden | Dein Gutachten Direkt</title>
        <meta name="description" content="Werden Sie Partner und profitieren Sie von unserem bundesweiten Gutachten-Netzwerk. Faire Provisionen, einfacher Ablauf." />
        <link rel="canonical" href="https://www.dein-gutachten-direkt.de/partner" />
      </Helmet>
      <Header />
      <main>
        <HeroPartner />
        <SoFunktioniertPartner />
        
        {/* Pricing Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Wählen Sie Ihr Partner-Paket
              </h2>
              <p className="text-lg text-gray-600">
                Faire Konditionen für jeden Bedarf
              </p>
            </div>
            
            <PricingCards onSelectPackage={handleSelectPackage} />
            
            {/* Lohnt sich Rechner */}
            <div className="mt-16 max-w-4xl mx-auto bg-white rounded-2xl p-8 border-2 border-brand-green/20 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-brand-green/10 rounded-xl flex items-center justify-center">
                  <Calculator className="h-6 w-6 text-brand-green" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">
                  Wann lohnt sich welches Paket?
                </h3>
              </div>
              
              <p className="text-gray-700 mb-6">
                Schon ab wenigen Fällen pro Monat kann sich ein höheres Paket lohnen.
              </p>
              <p className="text-sm text-gray-600 mb-6 font-semibold">
                Beispielrechnung bei Ø 500 € Grundhonorar. Paketpreise inkl. MwSt.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="text-brand-green font-semibold mb-3">1 Fall/Monat</div>
                  <div className="text-sm text-gray-600 space-y-2">
                    <div>Starter: 150€ Provision</div>
                    <div className="text-brand-green font-semibold">Pro: 200€ Provision ✓</div>
                    <div>Premium: 250€ Provision</div>
                  </div>
                  <div className="text-xs text-gray-500 mt-3">
                    * Bei Ø 500€ Grundhonorar
                  </div>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="text-brand-green font-semibold mb-3">2-3 Fälle/Monat</div>
                  <div className="text-sm text-gray-600 space-y-2">
                    <div>Starter: 300-450€</div>
                    <div className="text-brand-green font-semibold">Pro: 400-600€ ✓</div>
                    <div>Premium: 500-750€</div>
                  </div>
                  <div className="text-xs text-gray-500 mt-3">
                    Pro lohnt sich ab 1-2 Fällen
                  </div>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="text-brand-green font-semibold mb-3">5+ Fälle/Monat</div>
                  <div className="text-sm text-gray-600 space-y-2">
                    <div>Starter: 750€+</div>
                    <div>Pro: 1.000€+</div>
                    <div className="text-brand-green font-semibold">Premium: 1.250€+ ✓</div>
                  </div>
                  <div className="text-xs text-gray-500 mt-3">
                    Premium optimal ab 4-5 Fällen
                  </div>
                </div>
              </div>
              
              <p className="text-sm text-gray-600 mt-6 text-center">
                Provision wird vom Netto-Grundhonorar berechnet. Paket jederzeit wechselbar.
              </p>
            </div>
          </div>
        </section>
        
        <WarumPartner />
        <WieEsFunktioniert />
        <PartnerCTA />
      </main>
      <Footer />
    </div>
  );
};

export default PartnerPage;